export function formatPrice(price: number): string {
    return new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
    }).format(price);
}

export function discountPercentage(
    original: number,
    discounted: number,
): number {
    if (original === 0) return 0;
    return Math.round((1 - discounted / original) * 100);
}
